import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/messaging/constants';
import { messagingQueryKeys } from '@/modules/messaging/queries/queryKeys';
import type { MessageThreadApi } from '@/modules/messaging/types';
import { invalidateQuery } from '@/utils/queries';

interface UpdateMessageThreadParams {
  threadId: string;
  status: MessageThreadApi['status'];
}

export const useUpdateMessageThreadMutation = () => {
  return useMutation({
    mutationFn: async ({ threadId, status }: UpdateMessageThreadParams) => {
      const { data } = await fetchClient.PUT(endpoints.thread, {
        params: {
          path: {
            id: threadId,
          },
        },
        body: {
          status,
        },
      });
      return data;
    },
    onSettled: (_data, _error, variables) => {
      const { threadId } = variables;

      invalidateQuery(messagingQueryKeys.threads())();
      invalidateQuery(messagingQueryKeys.thread(threadId))();
    },
  });
};
